import { render, staticRenderFns } from "./BrandsMarketplaceDisplay.vue?vue&type=template&id=19ec891a&scoped=true&"
import script from "./BrandsMarketplaceDisplay.vue?vue&type=script&lang=js&"
export * from "./BrandsMarketplaceDisplay.vue?vue&type=script&lang=js&"
import style0 from "./BrandsMarketplaceDisplay.vue?vue&type=style&index=0&id=19ec891a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19ec891a",
  null
  
)

export default component.exports